import {useSelector} from 'react-redux'
import {selectAllTags} from '../state/accountTagsSlice'

export const useTags = (type)=>{
	return useSelector(state=>{
		if( type === 'all') return selectAllTags(state)
	})
}